import { render, staticRenderFns } from "./AgentSection.vue?vue&type=template&id=b8d60ede&scoped=true"
import script from "./AgentSection.vue?vue&type=script&lang=js"
export * from "./AgentSection.vue?vue&type=script&lang=js"
import style0 from "./AgentSection.vue?vue&type=style&index=0&id=b8d60ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d60ede",
  null
  
)

export default component.exports